import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import DonutPlot from '../../../graphics/DonutPlot';
import { Title } from './styles';
import { Props } from './types';

const Donut: React.FC = () => {
  const dataState: Props = useSelector(
    (state: ApplicationState) => state.DashSla.data['tipoSolicitacao']
  );

  const dataFilter = dataState?.data?.map((item) => {
    return { type: item.tipo, value: item?.valor, percentage: item?.percentual };
  });

  const data =
    dataFilter?.length > 0 ? dataFilter : [{ type: 'Sem dados', value: 0, percentage: 0 }];

  return (
    <>
      <Title>Atendimento por solicitação </Title>
      <div style={{ width: '100%', padding: '10px' }}>
        <DonutPlot data={data} total={dataState?.total} />
      </div>
    </>
  );
};

export default Donut;
